<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <template-listing-base
        v-bind:title="resource('TemplatePrimaryListing_Listing_Title')"
        v-bind:list-title="resource('TemplatePrimaryListing_Listing_ListTitle')"
        v-bind:templates="templates"
        v-bind:can-search="true"
        v-bind:can-create="true"
    >
        <template v-slot:template-listing-item="{template}">
            <template-primary-listing-item
                v-bind:class="{ selected: selectedTemplate === template }"
                v-bind:template="template"
                @template-selected="$emit('template-selected', template.Id)"
                @template-deleted="removeTemplate(template)"
            ></template-primary-listing-item>
        </template>
    </template-listing-base>
</template>

<script>
    import templateApi from '../../../../Api/template-manager';

    import templateStates from '../../template-states';

    import resourceMixin from '../../../../Util/Mixins/resources';
    import growlApi from '../../../../Util/growler';

    import TemplateListingBase from './TemplateListingBase.vue';
    import TemplatePrimaryListingItem from './TemplatePrimaryListingItem.vue';

    export default {
        name: "template-primary-listing",
        components: {
            TemplateListingBase,
            TemplatePrimaryListingItem
        },
        mixins: [resourceMixin],
        created() {
            const vm = this;

            //templateApi.getTemplateList(templateStates.draft)
            templateApi.getTemplateList(templateStates.publishable)
                .then(
                    data => vm.templates = data,
                    err => growlApi.error(err)
                );
        },
        methods: {
            selectTemplate(template){
                const vm = this;

                vm.selectedTemplate = template;
            },
            removeTemplate(template){
                const vm = this;

                //Can't splice without a proper index
                const idx = vm.templates.indexOf(template);
                if(idx !== -1){
                    vm.templates.splice(idx, 1);
                }
            }
        },
        data(){
            return {
                templates: [],
                selectedTemplate: null
            }
        }
    };
</script>
